/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAdmission } from 'app/shared/model/admission.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IParamedic } from 'app/shared/model/paramedic.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';

export interface IParamedicReferral {
  id?: string;
  referralTypeCode?: string;
  referralName?: string;
  active?: boolean | null;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  cursor?: number;
  served?: boolean | null;
  referralNotes?: string | null;
  accepted?: boolean | null;
  rejected?: boolean | null;
  rejectNotes?: string | null;
  patientType?: keyof typeof PatientType | null;
  exposed?: boolean | null;
  sourceAppointmentId?: string | null;
  admission?: IAdmission | null;
  referredTo?: IDoctor;
  referredAt?: IHospital;
  referredBy?: IParamedic;
  glucoUser?: IGlucoUser | null;
}

export const defaultValue: Readonly<IParamedicReferral> = {
  active: false,
  served: false,
  accepted: false,
  rejected: false,
  exposed: false,
};
